import { lazy, LazyExoticComponent, Suspense } from "react";

import { Brand } from "../../../store/slices/environmentSlice";
import { useTypedSelector } from "../../../store/store";
import LoadingContainer from "../../containers/LoadingContainer";

const DefaultSignIn = lazy(() => import("./default"));
const VidSignIn = lazy(() => import("./vid"));

const PAGES_BY_BRAND: Record<Brand, LazyExoticComponent<() => JSX.Element>> = {
  default: DefaultSignIn,
  vid: VidSignIn,
  dtw: DefaultSignIn,
  aov: DefaultSignIn,
  cen: DefaultSignIn,
};

function RootSignIn() {
  const { brand } = useTypedSelector((state) => state.environment);

  const PageByBrand = PAGES_BY_BRAND[brand] ?? DefaultSignIn;

  return (
    <Suspense
      fallback={
        <LoadingContainer isLoading>
          <></>
        </LoadingContainer>
      }>
      <PageByBrand />
    </Suspense>
  );
}

export default RootSignIn;
